import { createFileRoute } from '@tanstack/react-router';
import {
  zContactType,
  zFunction,
  zMarketSearchNeedsAttention,
  zMarketSearchStatus,
  zPipelineRoleType,
  zSeniority,
} from 'client/zod.gen';
import { zFiltersArray } from 'helpers/router';
import { z } from 'zod';

// The table's filters live in the URL so a filtered view can be shared or
// reloaded. `status` is already a filter array in the private route's schema.
export const marketSearchesSchema = z.object({
  contact_type: zFiltersArray(zContactType),
  functions: zFiltersArray(zFunction),
  needs_attention: zFiltersArray(zMarketSearchNeedsAttention),
  role_type: zFiltersArray(zPipelineRoleType),
  search_uuid: zFiltersArray(z.string().uuid()),
  seniority: zFiltersArray(zSeniority),
  status: zFiltersArray(zMarketSearchStatus),
});

export const Route = createFileRoute(
  '/_private/_route/_internal/tools/market-searches/',
)({
  validateSearch: marketSearchesSchema,
});
